var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "view-contanier" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "tab" }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "permissson",
                rawName: "v-permissson",
                value: "YSTJ",
                expression: "'YSTJ'",
              },
            ],
            staticClass: "tabItem",
            class: { active: _vm.active === 1 },
            on: {
              click: function ($event) {
                return _vm.changeType(1, "YSTJ")
              },
            },
          },
          [_vm._v("营收统计")]
        ),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "data",
      },
      [
        _c(
          "el-form",
          { ref: "form", attrs: { model: _vm.form, "label-position": "top" } },
          [
            _vm.active === 0
              ? _c(
                  "div",
                  {
                    staticClass: "radio",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c("span", [_vm._v("数据类型")]),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.type,
                          callback: function ($$v) {
                            _vm.type = $$v
                          },
                          expression: "type",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("客服数据"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { attrs: { label: _vm.label } },
              [
                _vm.active !== 3
                  ? _c("el-date-picker", {
                      staticStyle: { width: "320px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                        "unlink-panels": "",
                        "picker-options": _vm.pickerOptions,
                      },
                      model: {
                        value: _vm.form.date,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "date", $$v)
                        },
                        expression: "form.date",
                      },
                    })
                  : _c("el-date-picker", {
                      staticStyle: { width: "320px" },
                      attrs: {
                        type: "date",
                        placeholder: "截止日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.form.dateTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "dateTime", $$v)
                        },
                        expression: "form.dateTime",
                      },
                    }),
              ],
              1
            ),
            _vm.type === 2
              ? _c("el-form-item", { attrs: { label: "单号" } }, [
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-popover",
                        {
                          ref: "popover",
                          staticClass: "searchPop",
                          attrs: {
                            placement: "top",
                            title: "批量搜索",
                            trigger: "click",
                            width: "378",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "close",
                              on: { click: _vm.closeSearchPanel },
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          ),
                          _c("base-muti-input", {
                            ref: "baseMutiInput",
                            attrs: { default: _vm.numbers },
                            model: {
                              value: _vm.numbers,
                              callback: function ($$v) {
                                _vm.numbers = $$v
                              },
                              expression: "numbers",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "16px 0 0",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleEmpty },
                                },
                                [_vm._v("清空")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "sure",
                                  on: { mousedown: _vm.handleConfirm },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticClass: "input-search",
                        staticStyle: { width: "320px" },
                        attrs: {
                          value: _vm.searchVal,
                          placeholder: "请输入单号",
                        },
                        on: { focus: _vm.handleFocus },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.active === 3
              ? _c(
                  "div",
                  { staticClass: "radio" },
                  [
                    _c("span", [_vm._v("查询类型")]),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.operationsType,
                          callback: function ($$v) {
                            _vm.operationsType = $$v
                          },
                          expression: "operationsType",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("外部"),
                        ]),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("内部"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.active === 3
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "permissson",
                            rawName: "v-permissson",
                            value: "preview",
                            expression: "'preview'",
                          },
                        ],
                        staticClass: "derive flex_c_c",
                        staticStyle: { width: "150px" },
                        on: {
                          click: function ($event) {
                            return _vm.review()
                          },
                        },
                      },
                      [_vm._v("预览")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "permissson",
                            rawName: "v-permissson",
                            value: "derive_d",
                            expression: "'derive_d'",
                          },
                        ],
                        staticClass: "derive flex_c_c",
                        staticStyle: { width: "150px" },
                        on: {
                          click: function ($event) {
                            return _vm.deriveDash(_vm.active)
                          },
                        },
                      },
                      [_vm._v("导出")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.active === 3
              ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "permissson",
                          rawName: "v-permissson",
                          value: "email-send",
                          expression: "'email-send'",
                        },
                      ],
                      staticClass: "derive flex_c_c",
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [_vm._v("邮件发送")]
                  ),
                ])
              : _vm._e(),
            _vm.active === 2
              ? _c(
                  "div",
                  { staticClass: "radio" },
                  [
                    _c("span", [_vm._v("提单类型")]),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.mblType,
                          callback: function ($$v) {
                            _vm.mblType = $$v
                          },
                          expression: "mblType",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 10000 } }, [
                          _vm._v("所有"),
                        ]),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("海运"),
                        ]),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("空运"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.active !== 3
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.derive,
                        expression: "derive",
                      },
                    ],
                    staticClass: "derive flex_c_c",
                    attrs: { "v-permissson": _vm.derive },
                    on: {
                      click: function ($event) {
                        return _vm.deriveStatistics(_vm.active)
                      },
                    },
                  },
                  [_vm._v("导出")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("EmailSendDialog", {
          attrs: {
            dialogVisible: _vm.dialogVisible,
            dateTime: _vm.form.dateTime,
          },
          on: {
            cancel: function ($event) {
              _vm.dialogVisible = false
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }